import { InlineWidget } from 'react-calendly';

const AssignSession = ({ data }: any) => {

    const { url, openBookASession, setOpenBookASession } = data || {};
    return (
        <div
            id="add-session"
            className={`modal fade ${openBookASession ? 'show' : ''}`} // removed vh-100 and show class
            tabIndex={-1}
            role="dialog"
            style={{ display: openBookASession ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            
            <div className="modal-dialog modal-xl modal-dialog-centered mx-auto">
                <div className="modal-content">
                    <div className="modal-header p-4 height-70 border-0 bg-gray-f2">
                        <h5 className="modal-title" id="staticBackdropLabel">
                            Book Session
                        </h5>
                        <button
                            type="button"
                            className="btn-close btn-close-small"
                            onClick={() => {
                                setOpenBookASession(false)
                            }}
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body p-o">
                        <InlineWidget
                            url={url ?? ''}
                            styles={{ height: '100%', minHeight: '800px', position:'relative' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssignSession;
